import React from 'react'
import { Box } from 'components/Layout'
import TextInput from 'components/TextInput'
import { Text } from 'components/Typography'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { COLOR } from 'theme'
import { CoordinateInput } from '@modmd/data'
import { FormikTouched } from 'formik'

interface Coordinate {
  lat: number
  lon: number
}
type Props = {
  onChange: (event: CoordinateInput[]) => void
  data: Coordinate[] | undefined
  errorMessage: Array<{ lat: string; lon: string }> | undefined
  onBlur: () => void
  touched?: FormikTouched<Coordinate>[]
  kmlValues?: Array<Coordinate>
}

const MIN_COORDINATES = 3
const defaultLatLon = { lat: 0, lon: 0 }

const Coordinates = ({ onChange, data, errorMessage, onBlur, touched, kmlValues }: Props) => {
  const initialValues = kmlValues?.length ? kmlValues : Array(MIN_COORDINATES).fill(defaultLatLon)
  const [coordinates, setCoordinates] = React.useState<Array<Coordinate>>(
    data ? [...data.slice(0, -1)] : initialValues
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => onChange(coordinates), [coordinates])
  React.useEffect(() => {
    if (kmlValues?.length) setCoordinates(kmlValues)
  }, [kmlValues])

  return (
    <Box>
      <Text>Coordinates</Text>
      {coordinates.map((item, index) => (
        <Box display="flex" flexDirection="row" alignItems="center" key={index.toString()}>
          <TextInput
            pr="1rem"
            type="number"
            label="Latitude"
            placeholder="0.00000"
            value={item.lat ? item.lat : ''}
            onChange={(e) => {
              coordinates[index] = { ...coordinates[index], lat: Number(e.target.value) }
              setCoordinates([...coordinates])
            }}
            onBlur={onBlur}
            errorMessage={touched ? errorMessage?.[index]?.lat : ''}
          />
          <TextInput
            type="number"
            label="Longitude"
            placeholder="0.00000"
            value={item.lon ? item.lon : ''}
            onChange={(e) => {
              coordinates[index] = { ...coordinates[index], lon: Number(e.target.value) }
              setCoordinates([...coordinates])
            }}
            onBlur={onBlur}
            errorMessage={touched ? errorMessage?.[index]?.lon : ''}
          />
          {coordinates.length > MIN_COORDINATES && (
            <Button
              appearance="ghost"
              style={{ backgroundColor: COLOR.white }}
              onClick={() => {
                setCoordinates(coordinates.filter((_, arrIndex) => arrIndex !== index))
              }}
            >
              <Icon.Close color={COLOR.danger} />
            </Button>
          )}
        </Box>
      ))}
      <Box display="flex" justifyContent="end" pb="1rem">
        <Button
          onClick={() => setCoordinates([...coordinates, defaultLatLon])}
          colorVariant="secondary"
        >
          + Add coordinate
        </Button>
      </Box>
    </Box>
  )
}

export { Coordinates }
